export const MAX_SOURCE_PIXELS = 80_000_000
export const MAX_SOURCE_PIXELS_LOW_MEMORY = 40_000_000
export const PREVIEW_MAX_DIMENSION = 2048

export enum SourcePixelBudget {
  Standard = 'standard',
  LowMemory = 'low-memory',
}

export interface SourcePixelLimit {
  budget: SourcePixelBudget
  maximumPixels: number
}

interface NavigatorWithDeviceMemory extends Navigator {
  readonly deviceMemory?: number
}

export function reportedDeviceMemory(browserNavigator: Navigator): number | undefined {
  return (browserNavigator as NavigatorWithDeviceMemory).deviceMemory
}

export function sourcePixelLimit(deviceMemory: number | undefined): SourcePixelLimit {
  if (deviceMemory !== undefined && (!Number.isFinite(deviceMemory) || deviceMemory <= 0)) {
    throw new Error('Navigator deviceMemory must be a positive finite number when provided')
  }
  if (deviceMemory !== undefined && deviceMemory <= 2) {
    return {
      budget: SourcePixelBudget.LowMemory,
      maximumPixels: MAX_SOURCE_PIXELS_LOW_MEMORY,
    }
  }
  return {
    budget: SourcePixelBudget.Standard,
    maximumPixels: MAX_SOURCE_PIXELS,
  }
}
